import { ethers } from "ethers";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { Web3Provider } from "@ethersproject/providers";
import {
  INFURA_PROVIDERS,
  MAX_TOKENS,
  PRICE_IN_ETHEREUM,
} from "../../constants";
import { AppError, AppStatus } from "../../types";
import { Web3AbiService } from "../abi/Web3AbiService";
import { AbiService } from "../abi";
import { BasicEthereumService } from "./BasicEthereumService";
import { AbiServicePool } from "../abi/AbiServicePool";
import { isMobile } from "../isMobile";

const { createAlchemyWeb3 } = require("@alch/alchemy-web3");

const isMetaMaskConnected = async (provider: ethers.providers.Web3Provider) => {
  const accounts = await provider.listAccounts();
  return accounts.length > 0;
};

export class Web3Service extends BasicEthereumService {
  error?: AppError;

  mintedCount = 0;

  provider?: ethers.providers.Web3Provider = undefined;

  abi?: AbiService;

  writableAbi?: AbiService;

  currentProvider?: any;

  static MAX_TOKENS = MAX_TOKENS;

  tokenPrice?: string;

  wallet?: string;

  static checkIfMetaMaskConnected(provider: Web3Provider) {
    return isMetaMaskConnected(provider);
  }

  async getMintedCount() {
    const mintedCountBN = await this.abi?.getMintedCount();
    return mintedCountBN || 0;
  }

  initReadAbi(w3?: Web3) {
    const abi = new AbiServicePool();

    const web3 = createAlchemyWeb3(
      "https://polygon-mainnet.g.alchemy.com/v2/ao4978ER45x7Q4n0_O_AJ3bVfvrhhKZ-"
    );

    (abi as AbiServicePool).add(new Web3AbiService(web3));

    if (w3) {
      (abi as AbiServicePool).add(new Web3AbiService(w3));
    }

    /**
     * Добавляем наши infura-провайдеры в AbiServicePool
     */
    // INFURA_PROVIDERS.map((p) =>
    //   (abi as AbiServicePool).add(
    //     new Web3AbiService(new Web3(new Web3.providers.HttpProvider(p)))
    //   )
    // );

    return abi;
  }

  async init(): Promise<AppStatus> {
    console.info("Initializing Web3");

    const defaultW3 = new Web3();

    this.abi = this.initReadAbi(defaultW3);

    if (
      !this.currentProvider &&
      // @ts-ignore
      !defaultW3?.givenProvider?.selectedAddress
    ) {
      return AppStatus.Disconnected;
    }

    if (!this.currentProvider) {
      this.currentProvider = defaultW3.givenProvider;
    }

    const web3 = new Web3(this.currentProvider!);

    this.writableAbi = new Web3AbiService(web3);

    // let isStarted = false;
    // try {
    //   isStarted = await this.checkIfStarted();
    // } catch (e) {
    //   if (this.error) {
    //     throw new Error(this.error);
    //   }
    // }
    //
    // if (!isStarted) {
    //   return AppStatus.NotStarted;
    // }

    const mintedCount: number = await this.initMintedCount();
    const tokenPrice: string = await this.initCurrentTokenPrice();
    if (this.error) {
      throw new Error(this.error);
    }

    this.mintedCount = mintedCount;
    this.tokenPrice = tokenPrice;
    this.wallet = defaultW3?.givenProvider?.selectedAddress;

    this.provider = this.currentProvider;
    return AppStatus.Connected;
  }

  private createWeb3Modal() {
    return new Web3Modal({
      cacheProvider: true, // optional
      // disableInjectedProvider: false,
      providerOptions: {},
      // providerOptions: !isMobile
      //   ? {
      //       walletconnect: {
      //         package: WalletConnectProvider,
      //         options: {
      //           // Mikko's test key - don't copy as your mileage may vary
      //           infuraId: "8043bb2cf99347b1bfadfb233c5325c0",
      //         },
      //       },
      //     }
      //   : {},
    });
  }

  async switchToPolygon() {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x89" }],
      });
    } catch (switchError: any) {
      console.info("switchError", switchError);
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x89",
                rpcUrl: "https://polygon-rpc.com",
              },
            ],
          });
        } catch (addError) {
          console.info("addError", addError);
        }
      }
    }
  }

  async connect(): Promise<AppStatus | undefined> {
    const web3Modal = this.createWeb3Modal();

    try {
      await this.switchToPolygon();
      this.currentProvider = await web3Modal.connect();
      return await this.init();
    } catch (e: any) {
      if (e?.code === -32002) {
        throw new Error(AppError.RequestAlreadyPending);
      }
    }
  }

  amountToBn(n: number) {
    console.info(this.tokenPrice);
    return Web3.utils
      .toBN(this.tokenPrice || PRICE_IN_ETHEREUM)
      .mul(Web3.utils.toBN(n));
  }
}
